import React, { useState, useRef, useEffect } from 'react';
import { FaEllipsisV, FaTrashAlt, FaCopy } from 'react-icons/fa';

const DropdownMenu = ({ handleDelete, isDeletable }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Handle click outside to close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className="relative inline-block"
      ref={menuRef}
      style={{ position: 'absolute', right: 0, bottom: 0, zIndex: 100 }}
    >
      {/* Three-dot Button */}
      <button
        onClick={(e) => {
          e?.stopPropagation();
          setIsOpen(!isOpen);
        }}
        className="p-2 rounded-full hover:bg-gray-200 transition"
        style={{
          width: '100%',
          color: '#515053',
          display: 'flex',
          padding: '5px',
          border: '0px dashed #ABCAE8',
          cursor: 'pointer',
          fontWeight: 'bold',

          textTransform: 'none',
        }}
      >
        {/* <FaEllipsisV className="text-gray-600" /> */}
        <img src="./images/workflow/dots.svg" />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div
          className="absolute right-0 mt-2 w-44 bg-white shadow-md rounded-lg border"
          style={{
            width: '160px',
            position: 'absolute',
            zIndex: 999,
            padding: '15px',
            border: '2px solid #CCCCCC',
            background: '#ffffff',
            borderRadius: '10px',
            boxShadow: '0px 12px 31px #00000052',
            bottom: 'auto',
            top: '100%',
          }}
          onClick={(e) => e?.stopPropagation()}
        >
          {/* Delete Option */}
          <button
            className={`flex items-center w-full px-4 py-2 ${
              isDeletable
                ? 'text-gray-700 hover:bg-gray-100'
                : 'text-gray-400 cursor-not-allowed'
            } transition`}
            style={{
              width: '100%',
              color: '#515053',
              display: 'flex',
              padding: '5px',
              border: '0px dashed #ABCAE8',
              cursor: 'pointer',
              fontWeight: 'bold',
              backgroundColor: '#fff',
              textTransform: 'none',
            }}
            onClick={(e) => {
              e?.stopPropagation();
              if (isDeletable && handleDelete) {
                handleDelete();
                setIsOpen(false); // Close menu after action
              }
            }}
            disabled={!isDeletable}
          >
            <FaTrashAlt
              className={`mr-3 ${isDeletable ? 'text-red-500' : 'text-gray-400'}`}
            />
            &nbsp;Delete
          </button>

          <span
            style={{
              width: '160px',
              border: '0.5px solid #CCCCCC',
              display: 'block',
              margin: '10px 0',
              position: 'relative',
              left: '-15px',
            }}
          ></span>

          {/* Make a Copy Option */}
          <button
            disabled={true} // Change this dynamically based on a state
            className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 transition "
            style={{
              width: '100%',
              color: 'gray',

              border: '0px dashed #ABCAE8',
              cursor: 'not-allowed',
              fontWeight: 'bold',

              textTransform: 'none',
              opacity: 0.5,
            }}
            onClick={(e) => {
              e?.stopPropagation();
              alert('Make a Copy Clicked');
              setIsOpen(false);
            }}
          >
            <FaCopy className="mr-3 text-gray-500" />
            &nbsp;Make a Copy
          </button>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
